import React from 'react';

import { Link } from 'react-router-dom';

import FastViewModal from '../../Home/FastViewModal/FastViewModal';

// Styles
import styles from "../DashboardFileManagement/DashboardFileManagement.module.css"
import Dstyles from "../../Home/UserFilesToShow/Card/Estates.module.css"
import sliderStyles from "../../Home/CardsSlider/CardsSlider.module.css"
import cardStyles from "../../UserDashboard/UserMyAds/UserMyAdsCards/UserMyAdsCards.module.css"

//Images
import bedIcon from "../../../assets/img/DashboardICons/bedIcon.svg"
import meterIcon from "../../../assets/img/DashboardICons/meterIcon.svg"
import buildingIcon from "../../../assets/img/DashboardICons/buildingIcon.svg"
import locationIcon from "../../../assets/img/DashboardICons/locationIcon.svg"

export default function SaleReminderCard(props) {
    // console.log(props.cardData)
    const e2p = s => s?.toString()?.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])
    const [modalData, setModalData] = React.useState({
        show: false,
        id: "",
        loading: true
    })

    const modalHandler = (id) => {
        setModalData((prev) => {
            return { ...prev, id: id, show: true };
        })
    }

    return (
        <>
            <FastViewModal
                show={modalData.show}
                id={modalData.id}
                loading={modalData.loading}
                setModalData={setModalData}
                onHide={() => {
                    setModalData((prev) => {
                        return { ...prev, show: false };
                    })
                }}
                myFiles={props.myFiles}
            />

            {props.user ?
                props.cardData?.map((item, i) => (
                    <section className='position-relative' key={item.id}>
                        <div onClick={() => modalHandler(item.id)} className={`d-flex align-items-center justify-content-center ${sliderStyles.fastview_btn}`}>
                            <span className='ms-1'>
                                مشاهده سریع
                            </span>
                            <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M1.01662 7.16448C4.06662 2.79251 8.02127 0.5 11.9831 0.5C16.6362 0.5 20.6443 3.53129 23.0091 7.18363L23.0102 7.18535C23.1667 7.4285 23.2499 7.71155 23.2499 8.0007C23.2499 8.28933 23.167 8.57187 23.0111 8.81473C20.6483 12.5141 16.6661 15.5 11.9831 15.5C7.25032 15.5 3.34483 12.5203 0.987915 8.83171C0.827766 8.58304 0.744702 8.29255 0.749197 7.99677C0.753702 7.70025 0.845999 7.41172 1.01443 7.16763L1.01662 7.16448ZM2.24903 8.01956L2.25111 8.02279C4.42804 11.4304 7.91716 14 11.9831 14C16.0036 14 19.5679 11.4195 21.7474 8.0065L21.7489 8.00426C21.7495 8.00319 21.7499 8.00196 21.7499 8.0007C21.7499 8.00017 21.7498 7.99965 21.7497 7.99914C21.7496 7.9985 21.7493 7.99787 21.749 7.9973C19.5611 4.61915 15.9676 2 11.9831 2C8.63897 2 5.09927 3.93555 2.24903 8.01956ZM11.9991 5C10.3422 5 8.99907 6.34315 8.99907 8C8.99907 9.65685 10.3422 11 11.9991 11C13.6559 11 14.9991 9.65685 14.9991 8C14.9991 6.34315 13.6559 5 11.9991 5ZM7.49907 8C7.49907 5.51472 9.51379 3.5 11.9991 3.5C14.4844 3.5 16.4991 5.51472 16.4991 8C16.4991 10.4853 14.4844 12.5 11.9991 12.5C9.51379 12.5 7.49907 10.4853 7.49907 8Z" fill="#1D1D1D" />
                            </svg>
                        </div>
                        <Link to={{
                            pathname: `/فایل/${item.slug}`,
                            state: {
                                state: item
                            }
                        }} className={`d-flex align-items-center flex-column px-2 py-2 mt-3 mb-4 mx-md-1 mx-0 ${cardStyles.card_container}`}>
                            <div className='w-100 position-relative mb-3'>
                                <img className={Dstyles.card_img} loading="lazy" src={`https://backdev.azrmelk.com${item.imageUrl}`} alt="card-img" />
                                {/* <span className={`d-flex align-items-center justify-content-center ${Dstyles.card_imgs_nubmer_info}`}>۱/۸</span> */}
                            </div>

                            <div className='w-100 d-flex align-content-center justify-content-between px-2 mb-1'>
                                <Link to={{
                                    pathname: `/user-files-detail/${item.slug}`,
                                    state: item
                                }} className={Dstyles.card_title}>{e2p(item.title?.toString())}</Link>
                                {/* {props.savedFiles ?
                                    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg" className='pointer'>
                                        <path d="M14.75 21.5C14.5666 21.5005 14.3893 21.4338 14.2517 21.3125L8 15.7536L1.74828 21.3125C1.6401 21.4087 1.50639 21.4715 1.3633 21.4933C1.22021 21.5152 1.07385 21.4952 0.941874 21.4357C0.809902 21.3763 0.697959 21.2799 0.619552 21.1582C0.541145 21.0365 0.499626 20.8948 0.500003 20.75V3.5C0.500871 2.70462 0.817221 1.94206 1.37964 1.37964C1.94206 0.817218 2.70462 0.500869 3.5 0.5H12.5C13.2954 0.500869 14.0579 0.817218 14.6204 1.37964C15.1828 1.94206 15.4991 2.70462 15.5 3.5V20.75C15.5 20.9489 15.421 21.1397 15.2803 21.2803C15.1397 21.421 14.9489 21.5 14.75 21.5Z" fill="#21409A" />
                                    </svg>
                                    :
                                    <svg width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg" className='pointer'>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M1.37868 1.37868C1.94129 0.816071 2.70435 0.5 3.5 0.5H12.5C13.2956 0.5 14.0587 0.816071 14.6213 1.37868C15.1839 1.94129 15.5 2.70435 15.5 3.5V20.75C15.5 21.0453 15.3267 21.3132 15.0572 21.4342C14.7878 21.5552 14.4725 21.5068 14.2517 21.3106L8 15.7535L1.74827 21.3106C1.52753 21.5068 1.21218 21.5552 0.942758 21.4342C0.673333 21.3132 0.5 21.0453 0.5 20.75V3.5C0.5 2.70435 0.816071 1.94129 1.37868 1.37868ZM3.5 2C3.10218 2 2.72064 2.15804 2.43934 2.43934C2.15804 2.72064 2 3.10218 2 3.5V19.0799L7.50173 14.1894C7.78589 13.9369 8.21411 13.9369 8.49827 14.1894L14 19.0799V3.5C14 3.10218 13.842 2.72064 13.5607 2.43934C13.2794 2.15804 12.8978 2 12.5 2H3.5Z" fill="#8D8D8D" />
                                    </svg>
                                } */}

                            </div>

                            <div className="w-100 d-flex flex-column justify-content-center align-items-center align-items-md-start px-2 flex-wrap">
                                <h4 className={Dstyles.card_price}>{e2p(props.usePriceSeprator(item.totalPrice))}<span className={`me-1 ${Dstyles.card_text2}`}>تومان</span></h4>
                                <h4 className={`d-flex align-items-center justify-content-center ${Dstyles.card_text2}`}>{e2p(props.usePriceSeprator(item.meteragePrice))} تومان هر متر مربع</h4>
                            </div>

                            <div className={`w-100 d-flex justify-content-around align-items-center px-2 flex-wrap ${Dstyles.mb}`}>
                                <div className='d-flex align-items-center justify-content-center flex-column'>
                                    <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                        <img className="ms-2" src={bedIcon} alt="icon" />
                                        <div className={Dstyles.card_text2}>
                                            {e2p(item.roomCount?.toString())} خوابه
                                        </div>

                                    </div>
                                    <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                        <img className="ms-2" src={meterIcon} alt="icon" />
                                        <div className={Dstyles.card_text2}>
                                            {e2p(item.meterage?.toString())} متر
                                        </div>

                                    </div>
                                </div>
                                <div className='d-flex align-items-center justify-content-center flex-column'>
                                    <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                        <img className="ms-2" src={buildingIcon} alt="icon" />
                                        <div className={Dstyles.card_text2}>
                                            طبقه {e2p(item.floor?.toString())}
                                        </div>

                                    </div>
                                    <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                        <img className="ms-2" src={locationIcon} alt="icon" />
                                        <div className={Dstyles.card_text2}>
                                            {item.address.zone}
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </Link>
                    </section>
                ))
                :
                props.cardData != "" &&
                <div
                    className={`w-100 d-flex justify-content-xl-between justify-content-center flex-wrap align-items-center mt-3 me-3 ${styles.cards_container}`}
                    dir="rtl"
                >
                    {props.cardData?.map((item, i) => (
                        <div key={i} className={`d-flex align-items-center flex-column px-2 py-3 mt-3 mb-4 mx-md-3 mx-0 ${styles.card_container}`}>
                            <div className='w-100 position-relative mb-3'>
                                <img className={styles.card_img} loading="lazy" src={`https://backdev.azrmelk.com${item.imageUrl}`} alt="card-img" />
                                {/* <span className={`d-flex align-items-center justify-content-center ${styles.card_imgs_nubmer_info}`}>۱/۸</span> */}
                            </div>

                            <div className='w-100 text-end px-2 mb-1'>
                                <Link to={{
                                    pathname: `/card-detail/${item.id}`,
                                    state: {
                                        state: item
                                    }
                                }} className={styles.card_title}>{e2p(item.title?.toString())}</Link>
                            </div>

                            <div className="w-100 d-flex flex-column justify-content-center align-items-center align-items-md-start px-2 flex-wrap">
                                <h4 className={styles.card_price}>{e2p(props.usePriceSeprator(item.totalPrice))}<span className={`me-1 ${styles.card_text2}`}>تومان</span></h4>
                                <h4 className={`d-flex align-items-center justify-content-center ${styles.card_text2}`}>{e2p(props.usePriceSeprator(item.meteragePrice))} تومان هر متر مربع</h4>
                            </div>

                            <div className="w-100 d-flex justify-content-around align-items-center px-2 flex-wrap">
                                <div className='d-flex align-items-center justify-content-center flex-column'>
                                    <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                        <img className="ms-2" src={bedIcon} alt="icon" />
                                        <div className={styles.card_text2}>
                                            {e2p(item.roomCount?.toString())} خوابه
                                        </div>

                                    </div>
                                    <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                        <img className="ms-2" src={meterIcon} alt="icon" />
                                        <div className={styles.card_text2}>
                                            {e2p(item.meterage?.toString())} متر
                                        </div>

                                    </div>
                                </div>
                                <div className='d-flex align-items-center justify-content-center flex-column'>
                                    <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                        <img className="ms-2" src={buildingIcon} alt="icon" />
                                        <div className={styles.card_text2}>
                                            طبقه {e2p(item.floor?.toString())}
                                        </div>

                                    </div>
                                    <div className='d-flex justify-content-center align-items-center mt-2 mb-2'>
                                        <img className="ms-2" src={locationIcon} alt="icon" />
                                        <div className={styles.card_text2}>
                                            {item.address.zone}
                                        </div>

                                    </div>
                                </div>
                            </div>

                            <div className="w-100 d-flex justify-content-center justify-content-md-end align-items-center px-2">
                                <div className='d-flex align-items-center justify-content-center'>
                                    <Link to={{
                                        pathname: `/card-detail/${item.id}`,
                                        state: {
                                            state: item
                                        }
                                    }} className={`ms-1 ${styles.text_primary}`}>
                                        مشاهده بیشتر
                                    </Link>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-arrow-left" viewBox="0 0 16 16">
                                        <path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z" fill="#21409A" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            }
        </>
    )
}
